import {
  createComponentRendererRegistry,
  PartialTableComponents,
  TableComponents,
} from "src/components/ReactiveTable/components/ReactiveTable/componentRegistry";
import {
  AbstractFilters,
  AbstractRow,
} from "src/components/ReactiveTable/RtTypes";

/**
 * Объединяет дефолтные компоненты таблицы с кастомными
 */
export const mergeTableComponents = <
  TRow extends AbstractRow,
  TFilters extends AbstractFilters,
>(
  customComponents?: PartialTableComponents<TRow, TFilters>,
): TableComponents<TRow, TFilters> => {
  // Используем factory-функцию для создания типизированных дефолтных компонентов
  // Это обеспечивает строгую типизацию без необходимости в type assertions
  const baseComponents = createComponentRendererRegistry<TRow, TFilters>();

  if (!customComponents) {
    return baseComponents;
  }

  return {
    ...baseComponents,
    ...customComponents,
  };
};
